/**
 * Shared land-use value hygiene: the display path and the eligibility input
 * must apply the SAME filter, or the summary card and the eligibility card
 * classify the property from different values and contradict each other.
 */

// Generic/unhelpful values that must never override a real designation.
const GENERIC_LAND_USE_VALUES = [
  'לא ידוע',
  'יעוד עפ"י תכנית מאושרת אחרת',
  'יעוד עפ״י תכנית מאושרת אחרת',
];

export const isMeaningfulLandUse = (landUse) => {
  if (!landUse) return false;
  if (GENERIC_LAND_USE_VALUES.includes(landUse)) return false;
  // A master plan's "list of everything" (many commas) is not a designation.
  const commaCount = (String(landUse).match(/,/g) || []).length;
  if (commaCount > 2) return false;
  return true;
};
